// The one list of the EducationXR app's stores. AppLinks (the store badges
// on the downloads pages) and the app download page's "Other platforms"
// both read it, so a store is added, renamed or removed here only.
//
// key: config's app store key -- the app-store-proxy and /download/app/:key
// both take it. name: how a page names the store in words. group: the
// section AppLinks shows it under (APP_STORE_GROUPS). image: its badge. qr:
// a QR code to the store, for the phone stores.

export const APP_STORE_GROUPS = [
  {
    id: 'vr',
    title: 'Virtual Reality',
    details: 'Use VR headsets (Oculus, HTC, Samsung, Index etc) to explore learning content at the fullest level of immersion'
  },
  {
    id: 'mobile',
    title: 'Mobile Devices',
    details: '3D immersive content at your fingertips, from any mobile device, anywhere'
  },
  {
    id: 'desktop',
    title: 'Mac & PC',
    details: 'Use Mac or PC computers to explore immersive content'
  }
]

export const APP_STORES = [
  { name: 'Steam', key: 'QLXmpwuykoSNZyplanMW', group: 'vr', image: '/store-app-steam.png' },
  { name: 'Meta Quest', key: 'tlGkPVAjdnRlPVVSrPWf', group: 'vr', image: '/store-app-meta.png' },
  { name: 'Pico', key: 'HTGbpSAIaqlYhdxvcnqH', group: 'vr', image: '/store-app-pico.png' },
  { name: 'Android XR', key: 'fkeJilTdrhHBtGJCEftH', group: 'vr', image: '/store-app-androidxr.png' },
  { name: 'VIVE', key: 'NGSUJhLNBzxxQFDXZeug', group: 'vr', image: '/store-app-vive.png' },
  { name: 'iPhone & iPad', key: 'CMPDoBOvFLSdtiaIFOwW', group: 'mobile', image: '/store-app-ios.png', qr: '/qr-code-app-store.png' },
  { name: 'Android', key: 'OrtEUNWbVMWzrrbZrhsq', group: 'mobile', image: '/store-app-google.png', qr: '/qr-code-google-play.png' },
  { name: 'Mac', key: 'MbJldvViKuwXBmwddeny', group: 'desktop', image: '/store-app-mac.png' },
  { name: 'Windows', key: 'VUiBiRnHbEhSGvddsmlK', group: 'desktop', image: '/store-app-microsoft.png' }
]

// The store's page, through config's app-store-proxy (which sends the
// browser on to the store, or to our own download page for a direct
// download).
export const appStoreHref = key => `${process.env.REACT_APP_API_CONFIG}/api/ddd/app-store-proxy/${key}/store`

export const appStoresIn = groupID => APP_STORES.filter(store => store.group === groupID)
